// Australian state Acts → official legislation URL (top of Act page).
// Linking to a specific section in the URL is inconsistent across jurisdictions;
// landing on the Act home gets the user to the right place to find the section.
export const ACT_URLS = {
 QLD: "https://www.legislation.qld.gov.au/view/html/inforce/current/act-2008-073",
 NSW: "https://legislation.nsw.gov.au/view/html/inforce/current/act-2010-042",
 VIC: "https://www.legislation.vic.gov.au/in-force/acts/residential-tenancies-act-1997",
 SA: "https://www.legislation.sa.gov.au/lz?path=%2FC%2FA%2FRESIDENTIAL%20TENANCIES%20ACT%201995",
 WA: "https://www.legislation.wa.gov.au/legislation/statutes.nsf/main_mrtitle_24783_homepage.html",
 TAS: "https://www.legislation.tas.gov.au/view/html/inforce/current/act-1997-082",
 NT: "https://legislation.nt.gov.au/Legislation/RESIDENTIAL-TENANCIES-ACT-1999",
 ACT: "https://www.legislation.act.gov.au/a/1997-84/",
};

export function actUrlForState(state) {
 return ACT_URLS[(state || "QLD").toUpperCase()] || ACT_URLS.QLD;
}
